<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-aria/ssr';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-aria/ssr/package.json';

```tsx import
import {useCollator} from '@react-aria/ssr';
```

---
category: Server Side Rendering
keywords: [ssr, server side rendering, aria, next.js, gatsby]
---

# SSRProvider

<p>{docs.exports.SSRProvider.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['SSRProvider']} />

## Introduction

`SSRProvider` should be used as a wrapper for the entire application during server side rendering.
It works together with the [useId](useId.html) hook to ensure that auto generated ids are consistent
between the client and server by resetting the id internal counter on each request.
See the [server side rendering](ssr.html) docs for more information.

## Props

<PropTable component={docs.exports.SSRProvider} links={docs.links} />

## Example

```tsx
import {SSRProvider} from '@react-aria/ssr';

<SSRProvider>
  <YourApp />
</SSRProvider>
```
